import { useEffect } from 'react'

export type JotformiframeProps = { title: string; formId: string; height?: string }

export const PhnxJotformiframe: React.FC<JotformiframeProps> = ({
  title,
  formId,
  height = '539px',
}) => {
  useEffect(() => {
    const script = document.createElement('script')
    script.src = 'https://findex.jotform.com/s/umd/latest/for-form-embed-handler.js'
    script.async = true

    const handleScriptLoad = () => {
      if (window && typeof window.jotformEmbedHandler === 'function') {
        window.jotformEmbedHandler(
          `iframe[id='JotFormIFrame-${formId}']`,
          'https://findex.jotform.com/'
        )
      }
    }

    script.onload = handleScriptLoad
    document.body.appendChild(script)

    return () => {
      document.body.removeChild(script)
    }
  }, [formId])

  return (
    <iframe
      id={`JotFormIFrame-${formId}`}
      title={title}
      allow="geolocation; microphone; camera; fullscreen"
      src={`https://findex.jotform.com/${formId}`}
      frameBorder="0"
      style={{ minWidth: '100%', maxWidth: '100%', height, border: 'none' }}
      scrolling="no"
    ></iframe>
  )
}
